import moment from 'moment'
import { getProcessIdHeader } from '@/modules/banking/_helpers/generateProcessId'

/**
 *
 * @param {import('axios').AxiosResponse} response
 * @param {*} options
 * @returns {Object}
 */
export const createLogEntryData = (response, { method = 'GET' }) => {
  if (!response) throw new Error('No response given to create log entry data.')

  const {
    url: requestUrl,
    headers,
  } = response?.config || {}

  const statusCode = response.status

  return {
    requestId: headers?.requestId || null,
    ...getProcessIdHeader(headers?.processid),
    logDate: moment().toISOString(),
    httpMethod: method.toLowerCase(),
    requestUrl,
    statusCode,
  }
}

export default createLogEntryData
